import { useMemo } from 'react';

import { SearchBoxCriterionGroup } from '../../constants';
import { useSearchContext } from '../../hooks';
import { Criterion } from '../../types';
import { SearchProps } from '../types';

type UseProps = SearchProps & {
  allCriteria?: Criterion[];
  allValues?: Record<string, any>;
};

export const useProps = (props: SearchProps): UseProps => {
  const ctx = useSearchContext();

  const criteria = useMemo(() => {
    return (
      props.criteria ||
      ctx?.criteria?.filter(({ group }) => group === SearchBoxCriterionGroup)
    );
  }, [ctx?.criteria, props.criteria]);

  const selectedCriteria: Record<string, any> | undefined = useMemo(() => {
    if (props.values) {
      return props.values;
    }
    if (criteria) {
      const values: Record<string, any> = {};

      if (ctx) {
        for (const { key } of criteria) {
          if (key in ctx.values) {
            values[key] = ctx.values[key];
          }
        }
      }

      return values;
    }
    return ctx?.values;
  }, [props.values, criteria, ctx]);

  if (!ctx) {
    return props;
  }

  return {
    ...ctx,
    ...props,
    recentSearchKey: props.disableRecentSearch
      ? undefined
      : props.recentSearchKey || ctx.urlKey,
    criteria,
    values: selectedCriteria,
    allCriteria: ctx?.criteria,
    allValues: ctx?.values,
  };
};
